/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TargetCompany } from './TargetCompany';
import {
    TargetCompanyFromJSON,
    TargetCompanyFromJSONTyped,
    TargetCompanyToJSON,
} from './TargetCompany';

/**
 * 
 * @export
 * @interface CreateCallExecutionRequest
 */
export interface CreateCallExecutionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCallExecutionRequest
     */
    conference_phone_numbers?: Array<string>;
    /**
     * The phone number to call
     * @type {string}
     * @memberof CreateCallExecutionRequest
     */
    target_phone_number?: string;
    /**
     * 
     * @type {TargetCompany}
     * @memberof CreateCallExecutionRequest
     */
    target_company: TargetCompany;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCallExecutionRequest
     */
    goal_list: Array<string>;
}

/**
 * Check if a given object implements the CreateCallExecutionRequest interface.
 */
export function instanceOfCreateCallExecutionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "target_company" in value;
    isInstance = isInstance && "goal_list" in value;

    return isInstance;
}

export function CreateCallExecutionRequestFromJSON(json: any): CreateCallExecutionRequest {
    return CreateCallExecutionRequestFromJSONTyped(json, false);
}

export function CreateCallExecutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCallExecutionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'conference_phone_numbers': !exists(json, 'conference_phone_numbers') ? undefined : json['conference_phone_numbers'],
        'target_phone_number': !exists(json, 'target_phone_number') ? undefined : json['target_phone_number'],
        'target_company': TargetCompanyFromJSON(json['target_company']),
        'goal_list': json['goal_list'],
    };
}

export function CreateCallExecutionRequestToJSON(value?: CreateCallExecutionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'conference_phone_numbers': value.conference_phone_numbers,
        'target_phone_number': value.target_phone_number,
        'target_company': TargetCompanyToJSON(value.target_company),
        'goal_list': value.goal_list,
    };
}

